import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Button, Typography } from '@mui/material';
import QRCode from '@src/assets/images/qr-mobile-app.png';
import AppStore from '@src/assets/images/apple-store-vi.svg';
import CHPlay from '@src/assets/images/google-store-vi.svg';
import Phones from '@src/assets/images/phones.png';
import {
  AIVOICE_TTS_APP_STORE_URL,
  AIVOICE_TTS_GOOGLE_PLAY_URL,
} from '@src/constants/mobileApp';
import { StyledMobilePage } from './index.style';

const MobileAppV2 = () => {
  const { t } = useTranslation();
  const { openSidebar } = useSelector((state) => state.layout);
  const handleClickDownload = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <StyledMobilePage openSidebar={openSidebar}>
      <div className="mobile-app-content">
        <Typography className="tag">{t('mobileApp')}</Typography>
        <Typography className="title">{t('vbeeAiVoiceDescription')}</Typography>

        <Typography className="content">{t('appDescription')}</Typography>

        <Typography className="text-download">
          {t('downloadAppContent')}
        </Typography>
        <div className="download-app">
          <img src={QRCode} alt="vbee-qr-code" className="qr-code" />
          <div className="download-button-container">
            <Button
              onClick={() => handleClickDownload(AIVOICE_TTS_APP_STORE_URL)}
              className="download-button"
            >
              <img src={AppStore} alt="App Store" />
            </Button>
            <Button
              onClick={() => handleClickDownload(AIVOICE_TTS_GOOGLE_PLAY_URL)}
              className="download-button"
            >
              <img src={CHPlay} alt="CH Play" />
            </Button>
          </div>
        </div>
      </div>

      <img src={Phones} alt="Phones" className="phones-image" />
    </StyledMobilePage>
  );
};

export default MobileAppV2;
